import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AuthService,
  UserManagementService,
  UserEmployerModel,
  AppConfigService,
  InstanceTypes
} from 'ng-shared-library';

@Injectable({
  providedIn: 'root'
})
export class LandingPortalGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private appConfigService: AppConfigService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    var loggedIn = await this.authService.isLoggedIn().toPromise();

    if (!loggedIn) {
      return false;
    }

    if (this.authService.isInAllowedRole()) {
      var config = this.appConfigService.getConfig();
      var portalInfo = config.ExternalPortalInfo.map(info => {
        return {
          url: info.Url,
          name: info.DisplayName,
          hasAccess: this.authService.isInAnyRole(info.Roles)
        };
      });

      if (portalInfo.filter(g => g.hasAccess).length == 1) {
        var destination = portalInfo.find(g => g.hasAccess);
        window.location.href = destination.url;
        return false;
      }

      return true;
    }

    return this.router.parseUrl('/access-denied');
  }
}
